import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { close as closeModal } from '../../../modules/modal/actions';
import { termsConsent } from '../../registration/actions';
import { getTermsPage } from '../../../modules/content/selectors';
import backupContent from '../../../../resources/termsAndConditionsBackup.json';

export const ConfirmTerms = ({ accept, close, contentStackContent }) => {
  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = backupContent;
  }

  const handleAccept = () => {
    accept();
    close();
  };

  return (
    <div className="modal modal--zero-padding modal--justified confirm-terms">
      <div className="confirm-terms__header">
        {!!content.title && (
          <h1 className="terms-page__title">{content.title}</h1>
        )}
        {!!content.subtitle && (
          <h2 className="terms-page__subtitle">{content.subtitle}</h2>
        )}
      </div>
      <div className="modal__content-scrollable modal__content-scrollable--with-padding">
        {/* eslint-disable-next-line react/no-danger */}
        <div className="cms-content" dangerouslySetInnerHTML={{ __html: content.text }} />
      </div>
      <div className="modal__sticky-footer modal__button-line confirm-terms__button-line">
        <Button
          className="modal__button button--secondary"
          onClick={close}
        >
          Close
        </Button>
        <Button
          className="modal__button"
          onClick={handleAccept}
        >
          Accept
        </Button>
      </div>
    </div>
  );
};

ConfirmTerms.propTypes = {
  contentStackContent: PropTypes.object,
  close: PropTypes.func.isRequired,
  accept: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  contentStackContent: getTermsPage(state)
});

const mapDispatchToProps = {
  close: closeModal,
  accept: termsConsent
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmTerms);
